import axios from 'axios';
import {
    API_BASE_URL,
    API_URL_FETCH_RISK_RATINGS,
    API_URL_REPORT_CATEGORY_LIST_CASE,
    API_URL_GET_REPORT_DETAIL,
    API_URL_REPORT_ASSIGNED_ANALYST,
    API_URL_REPORT_REMOVE_LINK_CASE,
    API_URL_REPORT_ADD_LINK_CASE,
    API_URL_REPORT_UPDATE_ADMIN_DESCRIPTION,
    API_URL_REPORT_UPDATE_ADMIN_CATEGORIES,
    API_URL_REPORT_DELETE,
    API_URL_UPDATE_REPORT_STATUS,
    API_URL_REPORT_MARK_AS_DELETE
  } from "../../../../../constants";

  import  {
    CM_API_URL_UPDATE_REPORT_STATUS
} from 'src/common/constants';

export default class ReportIncidenService {
    static instance;

    static getInstance() {
        if (!ReportIncidenService.instance) {
            ReportIncidenService.instance = new ReportIncidenService();
        }
        return ReportIncidenService.instance;
    }

    async FetchCategories() {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(API_URL_REPORT_CATEGORY_LIST_CASE,{} ,{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async FetchOnlyPermission(id) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.get(`${API_BASE_URL}/report/${id}/analyst.list` ,{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async UpdateAdminCategories(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.put(`${API_URL_REPORT_UPDATE_ADMIN_CATEGORIES}` ,
        {
            reportCaseId: payload.reportCaseId,
            category: payload.category,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }
    async FetchRelatedAssets() {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.get(`${API_BASE_URL}/asset/index?pageSize=1000`,{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async RemoveAssets(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_BASE_URL}/report/remove_related_asset` ,
        {
            reportCaseId: payload.caseId,
            assetId: payload.assetId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok || false; 
    }

    async AddAssets(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_BASE_URL}/report/add_related_asset` ,
        {
            reportCaseId: payload.caseId,
            assetId: payload.assetId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok|| false; 
    }


    async FetchCasess(caseId) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.get(`${API_BASE_URL}/report/${caseId}/list_select_cases` ,{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async RemoveLinkedIncident(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_URL_REPORT_REMOVE_LINK_CASE}` ,
        {
            reportCase: payload.caseId,
            removedLinkedCase: payload.linkCaseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok || false; 
    }

    async AddLinkedIncident(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_URL_REPORT_ADD_LINK_CASE}` ,
        {
            reportCase: payload.caseId,
            addedLinkedCase: payload.linkCaseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok|| false; 
    }

    async FetchRiskRating() {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.get(API_URL_FETCH_RISK_RATINGS ,{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async FetchAnalystsAndAnalystAdmins() {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_BASE_URL}/analystAndAdminAnalyst.list` ,{},{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async ChangeAnalystsAndAnalystAdmins(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_BASE_URL}/report/${payload.caseId}/changeReadonlyAnalysts` ,
        {
            readonlyAnalysts: payload.readonlyAnalysts,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok|| false; 
    }

    async UpdateAdminDescription(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.put(`${API_URL_REPORT_UPDATE_ADMIN_DESCRIPTION}` ,
        {
            description: payload.description,
            reportCaseId: payload.caseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok|| false; 
    }

    async FetchIncidentReportOverView(caseId) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_URL_GET_REPORT_DETAIL}` ,
        {
            report_case_id: caseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response.data?.data || []; 
    }

    async updateAssignedAnalyst(payload){
        const response = await axios.post(`${API_URL_REPORT_ASSIGNED_ANALYST}`, payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data?.data || null;
    }

    async mentionCommentSearch(caseId, params = {}){
        const response = await axios.get(
            `${API_BASE_URL}/report/${caseId}/mentionCommentSearch`, 
            {
                params  :   params,
                headers :   {
                  Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
                }
            }
        );
    
        return response.data?.data;
      }
    
      async fetchTasks(caseId, params = {}){
        const response = await axios.post(`${API_BASE_URL}/report/${caseId}/tasks`, params, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async DeleteReport(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_URL_REPORT_DELETE}` ,
        {
            report_case_id: payload.caseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok || false; 
    }

    async UpdateStatus(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${ API_URL_UPDATE_REPORT_STATUS}` ,
        {
            status: payload.status,
            report_case_id: payload.caseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok || false; 
    }

    async PendingDeletionStatus(payload) {
        const accessToken = localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN");
        const response = await axios.post(`${API_URL_REPORT_MARK_AS_DELETE}` ,
        {
            reason: payload.reason,
            report_case_id: payload.caseId,
        },{
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
        });
        return response?.ok || false; 
    }
}
